import React from "react";
import BlogSection from "./BlogSection";
import rosemaryImg from "images/romarin.webp";
import psoriasisImg from "images/psoriasis.webp";
import soin from "images/soin.webp";
import ScrollToTop from "./ScrollToTop";
import { useTranslation } from "react-i18next";

const BlogPage = () => {
  const { t } = useTranslation();

  const posts = [
    {
      title: t("Romarin"),
      category: t("Hair & Body"),
      date: "September 20, 2022",
      author: "rehabbio",
      image: rosemaryImg,
      link: "/blog/romarin",
    },
    {
      title: t("Le Psoriasis"),
      category: t("Skin Care"),
      date: "September 25, 2022",
      author: "rehabbio",
      image: psoriasisImg,
      link: "/blog/psoriasis",
    },
    {
      title: t("Comment prendre soin de soi de façon responsable ?"),
      category: t("Tips"),
      date: "Mai 8, 2022",
      author: "rehabbio",
      image: soin,
      link: "/blog/soin",
    },
  ];

  return (
    <>
      <ScrollToTop />
      <BlogSection posts={posts} />

    </>
  );
};

export default BlogPage;
